import styled from "styled-components";

import "../../../../GlobalStyles/Font.css";

export const ContainerTasksUser = styled.div`
  max-width: 100%;
  padding: 16px;

  @media (min-width: 744px) {
    max-width: 712px;
    margin: 0 auto;
  }

  @media (min-width: 1024px) {
    max-width: 975px;
  }

  @media (min-width: 1440px) {
    max-width: 1392px;
  }
`;

export const ListTasks = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 744px) {
    flex-wrap: wrap;
    flex-direction: row;
    gap: 16px;
  }
`;

export const AddButtonTask = styled.button`
  width: 100%;
  height: 191px;
  background: #1ac63f;
  border-radius: 20px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    max-width: 396px;
    height: 212px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    height: 186px;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
    height: 165px;
  }

  @media (min-width: 1440px) {
    max-width: 448px;
    height: 240px;
  }
`;

export const SearchTask = styled.form`
  max-width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 18px 20px;
  margin-top: 40px;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 1440px) {
    max-width: 448px;
    padding: 15px 20px;
  }
`;

export const SearchTaskInput = styled.input`
  font-size: 16px;
  line-height: 19px;
  font-family: "Exo2 Medium";
  color: #000;

  &::placeholder {
    color: #000;
  }

  @media (min-width: 744px) {
    max-width: 348px;

    font-size: 20px;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
  }

  @media (min-width: 1440px) {
    max-width: 408px;

    font-size: 32px;
  }
`;

export const ButtonSearch = styled.button`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 18px;
  right: 20px;

  @media (min-width: 744px) {
    width: 24px;
    height: 24px;
    top: 18px;
    right: 16px;
  }

  @media (min-width: 1024px) {
    top: 18px;
    right: 18px;
  }

  @media (min-width: 1440px) {
    width: 38px;
    height: 38px;
    top: 15px;
    right: 14px;
  }
`;

export const ListTaskCard = styled.li`
  width: 100%;
  background: #1ac63f;
  border-radius: 20px;
  margin-top: 30px;
  position: relative;
  z-index: 1;

  &:first-child {
    margin-top: 0px;
  }

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 348px;

    &:nth-child(2) {
      margin-top: 0px;
    }
  }

  @media (min-width: 1024px) {
    max-width: 309px;

    &:nth-child(3) {
      margin-top: 0px;
    }
  }

  @media (min-width: 1440px) {
    max-width: 448px;
  }
`;

export const ButtonToggleContainer = styled.div`
  width: 50px;
  height: 50px;
  margin-bottom: 30px;

  @media (min-width: 1024px) {
    width: 70px;
    height: 70px;
    margin-bottom: 40px;
  }
`;

export const ButtonNotificationToggle = styled.button`
  width: 50px;
  height: 50px;
  background: #1ac63f;
  border-radius: 50%;
  fill: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 1024px) {
    width: 70px;
    height: 70px;
  }
`;

export const ButtonToggleContainerCard = styled.div`
  width: 50px;
  height: 50px;
  margin-bottom: 30px;

  @media (min-width: 1024px) {
    width: 70px;
    height: 70px;
    margin-bottom: 40px;
  }
`;

export const ButtonNotificationToggleCard = styled.button`
  display: none;
  width: 25px;
  height: 25px;
  background: #fff;
  border-radius: 50%;
  fill: #000;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 1024px) {
    width: 30px;
    height: 30px;
  }
`;

export const ContainerTask = styled.div`
  max-width: 100%;
  padding: 20px;
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  position: absolute;
  right: 16px;
  top: 16px;
`;

export const EditButton = styled.button`
  background: #fff;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    width: 30px;
    height: 30px;
  }
`;

export const DeleteButton = styled.button`
  background: #f64747;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    width: 30px;
    height: 30px;
  }
`;

export const ContainerInfoTask = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const NameTask = styled.h1`
  color: #fff;
  font-size: 16px;
  line-height: 19px;
  font-family: "Exo2 Bold";

  @media (min-width: 428px) {
    font-size: 20px;
  }
`;

export const DescriptionTask = styled.p`
  color: #fff;
  font-size: 16px;
  line-height: 19px;
  font-family: "Exo2 Light";
  margin-bottom: 20px;
  text-align: justify;
  margin-top: 20px;
  width: 100%;
  height: 110px;

  @media (min-width: 428px) {
    font-size: 18px;
  }
`;

export const DataTaskTitle = styled.h2`
  color: #fff;
  font-size: 16px;
  line-height: 19px;
  font-family: "Exo2 Bold";

  @media (min-width: 428px) {
    font-size: 20px;
  }
`;

export const DataTask = styled.span`
  color: #fff;
  font-size: 16px;
  line-height: 19px;
  font-family: "Exo2 Light";

  @media (min-width: 428px) {
    font-size: 18px;
  }
`;

export const TimeTaskTitle = styled.h2`
  color: #fff;
  font-size: 16px;
  line-height: 19px;
  font-family: "Exo2 Bold";

  @media (min-width: 428px) {
    font-size: 20px;
  }
`;

export const TimeTask = styled.span`
  color: #fff;
  font-size: 16px;
  line-height: 19px;
  font-family: "Exo2 Light";

  @media (min-width: 428px) {
    font-size: 18px;
  }
`;

export const ContainerDateTimeTask = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ContainerDisplayData = styled.div`
  display: flex;
  gap: 10px;
`;

export const ContainerDateTask = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerTimeTask = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerFeaturesTask = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ButtonDownload = styled.button`
  background: #fff;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    width: 30px;
    height: 30px;
  }
`;
